// 卡片状态: 1-可领取(claim), 2-可转盘/抽奖(spin), 3-需充值(deposit), 4-倒计时中(countdown), 5-已过期(expired), 6-进度条(progress), 7-无奖励(no_reward), 8-已领取(claimed)，9 进入裂变抽奖(Invite)，10 裂变抽奖未参与（Get Cash），11 未到期
export enum RewardStatusEnum {
  CLAIM = 1,
  SPIN = 2,
  DEPOSIT = 3,
  COUNT_DOWN = 4,
  EXPIRED = 5,
  PROGRESS = 6,
  NO_REWARD = 7,
  CLAIMED = 8,
  /** @desc 进入裂变抽奖 */
  INVITE = 9,
  /** @desc 裂变抽奖未参与 */
  INVITE_NOT_PARTICIPATE = 10,
  /** @desc 未到期 */
  NOT_EXPIRED = 11,
}

// 奖励类型:  10-欢迎礼包, 31-现金返还, 32-每周奖励, 33-每月奖励, 34-每日奖励, 35-晋级奖励, 36-日历奖励, 41-触发式奖励, 42-累充奖励,42 裂变抽奖 51-邀请奖励, 52-排行榜奖励，61 奖励解锁 bonus
export enum RewardTypeEnum {
  /** @desc 欢迎礼包 */
  WELCOME_GIFT = 10,
  /** @desc 现金返还 */
  CASH_BACK = 31,
  /** @desc 每周奖励 */
  WEEKLY_REWARD = 32,
  /** @desc 每月奖励 */
  MONTHLY_REWARD = 33,
  /** @desc 每日奖励 */
  DAILY_REWARD = 34,
  /** @desc 晋级奖励 */
  PROMOTION_REWARD = 35,
  /** @desc 日历奖励 */
  CALENDAR_REWARD = 36,
  /** @desc 触发式奖励 */
  TRIGGER_REWARD = 41,
  /** @desc 累充奖励 */
  CUMULATIVE_REWARD = 42,
  /** @desc 裂变转盘奖励 */
  TURNTABLE_REWARD = 43,
  /** @desc 邀请奖励 */
  INVITE_REWARD = 51,
  /** @desc 排行榜奖励 */
  RANKING_REWARD = 52,
  /** @desc 奖励解锁 */
  REWARD_UNLOCK = 61,
}